import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessagingGoogleTalk = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_386_8123)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M12.7467 26.3332C12.0667 26.2132 2.08 29.8665 2.08 29.8665C4.53333 27.5598 5.8 25.3332 5.50667 23.1198C4.14241 22.1011 3.02773 20.7855 2.24695 19.2725C1.46618 17.7594 1.03977 16.0886 1 14.3865C1 7.62648 7.66667 2.14648 16 2.14648C24.3333 2.14648 31 7.62648 31 14.3865C31 21.1465 24.28 26.6665 16 26.6665C14.9078 26.6526 13.819 26.541 12.7467 26.3332Z",
			stroke: "#EB6A1E",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M18.5469 6.40039C23.0802 7.33372 26.4402 10.6671 26.4402 14.6537C26.3992 15.9269 26.0548 17.1718 25.4356 18.285C24.8163 19.3982 23.9403 20.3474 22.8802 21.0537",
			stroke: "#EB6A1E",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_386_8123",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "white"
		})
	}) })]
});
export default SvgMessagingGoogleTalk;
